import { COLORS } from '@constants';
import { Button, Typography } from '@ui';
import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
    .ant-modal-content {
        padding: 24px;
    }

    .ant-modal-body {
        padding: 0;
    }
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0px;
    gap: 48px;
    width: 100%;
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 24px;
    width: 100%;
    flex: none;
    order: 0;
    flex-grow: 0;
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    gap: 10px;
    width: 100%;
    height: 36px;
    flex: none;
    order: 0;
    flex-grow: 0;
`;

export const ModalTitle = styled(Typography.Title)`
    &&& {
        margin: 0;
        height: 36px;
        font-size: 24px;
        line-height: 36px;
        font-weight: 500;
        color: ${COLORS.$gray100Black};
        flex: 1;
        order: 0;
        flex-grow: 0;
        white-space: nowrap;
    }
`;

export const CloseButton = styled(Button)`
    &&& {
        margin: 0;
        width: 24px;
        height: 24px;
        flex: none;
        order: 1;
        flex-grow: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background: ${COLORS.$gray15Black};
    flex: none;
    order: 1;
    flex-grow: 0;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: center;
    padding: 0px;
    width: 100%;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
`;

export const IconContainer = styled.div`
    width: 80px;
    height: 80px;
    flex: none;
    order: 0;
    flex-grow: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    justify-content: center;
    padding: 0px;
    flex: 1;
    min-width: 0;
`;

export const DescriptionText = styled(Typography.Text)`
    &&& {
        font-size: 20px;
        line-height: 28px;
        font-weight: 400;
        color: ${COLORS.$gray100Black};
        white-space: pre-wrap;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: flex-end;
    padding: 0px;
    width: 100%;
    height: 56px;
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;
`;

export const SetupMyselfButton = styled(Button)`
    &&& {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px 16px;
        gap: 8px;
        height: 56px;
        background: ${COLORS.$white};
        border: 2px solid ${COLORS.$gray20Black};
        border-radius: 8px;
        color: ${COLORS.$gray60Black};
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
        text-align: center;

        &:hover {
            background: ${COLORS.$white};
            border-color: ${COLORS.$gray20Black};
            opacity: 0.9;
        }

        &:active {
            background: ${COLORS.$white};
            border-color: ${COLORS.$gray20Black};
        }
    }
`;

export const InviteDeveloperButton = styled(Button)`
    &&& {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px 16px;
        gap: 8px;
        height: 56px;
        background: ${COLORS.$pinkGradient};
        border: 2px solid ${COLORS.$pink};
        border-radius: 8px;
        color: ${COLORS.$white};
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
        text-align: center;

        &:hover {
            background: ${COLORS.$pinkGradient};
            border-color: ${COLORS.$pink};
            opacity: 0.9;
        }

        &:active {
            background: ${COLORS.$pinkGradient};
            border-color: ${COLORS.$pink};
        }
    }
`;
